import { FC } from 'react';

import { NavigationItem } from '@telialt/models/src/Navigation';

import { MobileMenuItemComponent } from '../MobileMenuItemComponent/MobileMenuItemComponent';
import { MobileMenuItemLink } from './MobileMenuItemLink';

type Props = {
    item: NavigationItem;
    menuLevel: number;
    onOpenChildrenClick: () => void;
};

export const MobileMenuItem: FC<Props> = ({ item, menuLevel, onOpenChildrenClick }) => {
    if (item.component) {
        return <MobileMenuItemComponent item={item} menuLevel={menuLevel} />;
    }

    return <MobileMenuItemLink item={item} menuLevel={menuLevel} onOpenChildrenClick={onOpenChildrenClick} />;
};
